import { type BTFileSystem } from "legacyComponents/FileUploadContainer.types";

import { MediaType } from "types/enum";

import { BTExternalLink } from "commonComponents/btWrappers/BTExternalLink/BTExternalLink";
import { BTIconDownloadOutlined } from "commonComponents/btWrappers/BTIcon";
import { BTMenu } from "commonComponents/btWrappers/BTMenu/BTMenu";

interface IMenuItemDownloadProps {
    file: BTFileSystem;
    onClick: () => Promise<void>;
}

const MenuItemDownload = ({ file, onClick, ...antProps }: IMenuItemDownloadProps) => {
    if (file.mediaType === MediaType.Video) {
        return (
            <BTMenu.Item
                {...antProps}
                key={`downloadFile-menuitem-${file.id}`}
                testid={`downloadFile-menuitem-${file.id}`}
                onClick={onClick}
            >
                <BTIconDownloadOutlined /> Download
            </BTMenu.Item>
        );
    }

    return (
        <BTMenu.Item
            {...antProps}
            key={`downloadFile-menuitem-${file.id}`}
            testid={`downloadFile-menuitem-${file.id}`}
        >
            <BTExternalLink
                href={file.downloadDocPath}
                isUnderline={false}
                key={`downloadFile-${file.id}`}
                data-testid={`downloadFile-${file.id}`}
                onClick={onClick}
            >
                <BTIconDownloadOutlined /> Download
            </BTExternalLink>
        </BTMenu.Item>
    );
};

export default MenuItemDownload;
